/** Homepage / 日本語 */
export const landingHomeJa = {
  seo: {
    title: 'Veeso AI | 素のコンテンツを、納品できるデザインへ',
    description:
      'コピーをワンクリックで洗練されたデザインに。Veeso がソーシャル投稿、スライド、ページを自動レイアウト。完全編集可能、速くて正確。デザインスキル不要。',
    keywords:
      'AIデザイン, コンテンツファーストデザイン, SNSビジュアル, 中小企業マーケティング, 自動レイアウト, ビジュアルコンテンツツール',
  },
  nav: {
    logo_alt: 'Veeso AI',
    features: '機能',
    pricing: '料金',
    about: '私たちについて',
    spotlight: 'スポットライト',
    start_free: '無料で始める',
    workspace: 'ワークスペース',
    toggle_menu_aria: 'メニューを開閉',
    close_menu_aria: 'メニューを閉じる',
  },
  hero: {
    h1_line1: 'Veeso が素のコピーを',
    h1_line2: '即納品レベルのデザインに変換',
    subtitle: 'コンテンツを入れれば、デザインが出てくる。プロンプト不要、デザインスキル不要。',
    cta_mobile: '無料で始める',
    flying_card_alt: 'Veeso デザイン',
    file_type: {
      doc: 'DOC',
      xls: 'XLS',
      ppt: 'PPT',
      pdf: 'PDF',
      img: 'IMG',
      txt: 'TXT',
      md: 'MD',
    },
    flying_text: [
      'AI デザインツールで魅力的な SNS 投稿を作成',
      'アイデアを数分で美しいビジュアルに',
      'プロのデザインを、シンプルに',
      'AI が広げるクリエイティビティ',
      'より速く、よりスマートにデザイン',
      'コンセプトから制作まで',
      'AI アシストで創造性を解き放つ',
      '美しいデザインを数秒で',
      'デザインスキル不要',
      'あなたのビジョン、私たちの AI',
      '1080 × 1920',
      '16:9 比率',
      '4K 解像度',
      'Instagram 対応',
    ],
  },
  hero_prompt: {
    placeholder: 'デザインしたいものを入力してください',
    btn_design: 'デザインする',
    btn_designing: 'デザイン中...',
  },
  every_scene: {
    eyebrow: 'Veeso AI',
    heading_line1: '画像生成ではなく',
    heading_line2: '納品レベルのデザインを生成',
    cta_header: '今すぐデザイン',
    scene: {
      ecommerce: 'EC・通販',
      edm: 'メルマガ',
      hiring: '採用投稿',
      travel: 'トラベルガイド',
      academic: 'アカデミック',
      restaurant: 'レストラン',
      event_promo: 'イベント告知',
      brand: 'ブランドアイデンティティ',
      product_launch: '製品ローンチ',
      infographic: 'インフォグラフィック',
      campaign: '広告キャンペーン',
      presentation: 'プレゼンテーション',
      marketing_deck: 'マーケティング資料',
      pitch_deck: 'ピッチデック',
    },
    cta_card: {
      design_more: 'もっと\nデザイン',
      content_in_out: 'コンテンツを入れ\nデザインを出す',
      with_veeso_now_line1: 'VEESO で',
      with_veeso_now_line2: '今',
      with_veeso_now_line3: 'すぐに',
      link: '今すぐデザイン',
    },
  },
  every_step: {
    section_heading_line1: '思考のスピードで',
    section_heading_line2: 'デザインする',
    panel01: {
      label: '01 生成',
      title: 'テンプレート探しは、もう終わり。',
      body: 'コンテンツを貼り付けるだけで、Veeso AI がデザインを生成。書いたすべての言葉を、美しいタイポグラフィとレイアウトで残します。',
      cta: '今すぐデザイン',
    },
    panel02: {
      label: '02 編集',
      title: '画像ではない。テキストを直接編集',
      body: 'デザイン内のテキストを直接編集。画像編集に時間を浪費する必要はもうありません。',
      cta: '今すぐデザイン',
    },
    panel03: {
      label: '03 出力',
      title: 'あらゆる形式で書き出し。',
      body: '高品質な画像や PDF として書き出し、ワンクリックで SNS に直接シェアも可能。',
      cta: '今すぐデザイン',
    },
    more_explore_heading: '画像編集も Veeso AI で完結',
  },
  cards: {
    text_edit: {
      typewriter: {
        en_edit: '編集',
        en_text: 'テキスト',
      },
    },
    remove_bg: {
      primary: '背景除去。',
      secondary: '商品、人物、複雑なシーンも精密に切り抜き。',
    },
    upscale: {
      primary: '高解像度アップスケール。',
      secondary: 'AI による細部復元で、解像度を最大 4 倍に。',
    },
    image_styles: {
      primary: '多彩な画像スタイル。',
      secondary: '15 種類以上の AI スタイルで、どんな画像もワンクリック変換。',
      painting: 'ペインティング',
      realistic: 'リアリスティック',
      natural: 'ナチュラル',
      cyberpunk: 'サイバーパンク',
      neon: 'ネオン',
      futuristic: 'フューチャリスティック',
      magic: 'マジック',
      '3d_surrealism': '3D シュルレアリスム',
      line_art: 'ラインアート',
      webcomic: 'ウェブコミック',
      narrative_comic: 'ナラティブコミック',
      neo_folk_pop: 'ネオフォークポップ',
      halftone: 'ハーフトーン',
      old_halftone: 'オールドハーフトーン',
      surreal_arch: 'シュールアーチ',
    },
    deliver: {
      report: 'レポート',
      social_post: 'SNS 投稿',
      ppt_deck: 'PPT / スライド',
      newsletter: 'ニュースレター',
      print: '印刷物',
      banner: 'バナー',
    },
  },
  mock: {
    user_message:
      'Veeso AI 製品ローンチのウェイティングリストポスターを作って。Instagram 用に 1:1 比率、お祝いムードで。',
    ai_intro:
      '了解です！ウェイティングリストポスターを作成しましょう。デザインの方針はこちらです：',
    section: {
      design_concept_label: 'デザインコンセプト',
      design_concept_content:
        'お祝いムードのウェイティングリスト告知。大きな順位番号（#521,314）をヒーロー要素として配置。柔らかなパステルのグラデーションで温かみを演出し、花火のイメージで高揚感を加えます。タイポグラフィは見出しと補助テキストのコントラストを強く効かせます。',
      theme_label: 'テーマ',
      theme_value: 'お祝い',
      image_style_label: '画像スタイル',
      image_style_value: 'フェスティブ',
      ratio_label: '比率',
      ratio_value: '1:1',
    },
    canvas: {
      untitled_design: '無題のデザイン',
      composer_placeholder: '試してみますか？何か入力してください...',
      share_button: 'シェア',
      share_text:
        'コンテンツを数分でデザインに変えてくれる、とてもクールな AI デザインツールを見つけました。',
      copy_link: 'リンクをコピー',
      share_to: 'シェア先',
      collapse_sidebar: 'サイドバーを折りたたむ',
      expand_sidebar: 'サイドバーを展開',
      generating: '生成中...',
      frame_label: 'フレーム 1',
    },
    auth: {
      prompt: 'サインインまたは登録して、もっと速く、もっと良いデザインを。',
      sign_in: 'サインイン',
      sign_up: '新規登録',
    },
    poster: {
      title_line1: 'ようこそ',
      title_line2: 'Veeso AI へ',
      title_line3: 'あなたは',
      name: 'ROKI\nWANG',
      feature1: '誰でも\nVeeso AI で\nデザインできる',
      feature2: 'グラフィック\nデザインが\n得意です',
      feature3: 'ロングスクロール\nインフォグラフィック\nセールスメール',
      feature4: 'デック\nスライド\nブローシャー',
      number: '#521,314\n番目の\nユーザーです。',
      image_alt: 'デザイン',
      brand: 'Veeso',
    },
  },
  testimonials: {
    1: {
      content:
        'Veeso は私たちの SNS コンテンツの作り方を完全に変えました。今では SNS のすべての素材を Veeso AI で作成しています。以前はデザイナーを探して依頼する必要があり、時間もコストもかかっていました。',
      name: 'サラ・リー',
      role: 'マーケティングマネージャー',
    },
    2: {
      content:
        'デザイナーではない私が、プロ並みのプレゼンや投稿をこれほど速く作れることに驚きました。顧客向けの長文投稿の多くを Veeso AI でデザインしています。コンテンツを貼り付けるだけで自動でデザインしてくれます。',
      name: 'マーカス・ジョンソン',
      role: '創業者',
    },
    3: {
      content:
        'コンテンツクリエイターにとって最も重要なのは差別化です。AI は私が必要としているものを的確に理解し、私のスタイルでデザインしてくれます。これは競争のなかで大きな助けになります。',
      name: 'エミリー・ロドリゲス',
      role: 'コンテンツクリエイター',
    },
    4: {
      content:
        '製品を作った後、SNS でさまざまな形式とサイズで宣伝するために大量の素材が必要です。Veeso AI は、欲しいものを入力するだけで一つのキャンバスですべてを作れる素晴らしいツールです。一貫性と品質は他に類を見ません。',
      name: 'デイビッド・キム',
      role: 'プロダクトマネージャー',
    },
    5: {
      content:
        '私たちはさまざまなプラットフォームで多くの SNS アカウントを運用しています。ブランドに沿った素材は非常に重要です。今はデザイン素材とコピーをアップロードするだけで、同じスタイル、同じトーン、同じブランドアイデンティティでデザインされます。',
      name: 'リサ・トンプソン',
      role: 'SNS リード',
    },
    6: {
      content:
        '私たちは複数の国の異なるプラットフォームで製品を販売する小さなチームです。多言語で製品詳細ページやポスターを作ることは大きな課題でした。今はコンテンツを貼り付けるだけで、さまざまな言語で自動的にデザインされます。',
      name: 'アレックス・ワン',
      role: 'EC オーナー',
    },
    heading_line1: '誰のためにもデザイン',
    heading_line2: '誰もが楽しめる',
    subheading:
      'Veeso AI のユーザーは、プロのようにデザインができるようになり、\nより少ない時間と予算で強い成果を出し、ROI を高めています。',
  },
  faq: {
    1: {
      question: 'Veeso AI とは何ですか？',
      answer_p1:
        'デザインリソースが限られ、納期も厳しい中小企業オーナー、マーケター、運用担当者、創業者にとって、プロ品質のビジュアルを作ることは時間もコストもかかります。',
      answer_p2:
        'Veeso はコンテンツファーストのデザインツールです。コピーをワンクリック、1 分で、明快で洗練されたビジュアルに変えます。デザインスキルは不要です。',
      answer_p3:
        'コンテンツやテキストを貼り付けるだけで、次のような美しいデザインをすぐに生成できます：',
      product: [
        'SNS 投稿',
        'ポスター',
        'プレゼンテーション',
        'カルーセル',
        'マルチページパンフレット',
        'ロングフォームコンテンツ',
        'レストランメニュー',
        '招待状',
        'プルアップバナー',
        'チラシ',
        'アルバムカバー',
      ],
    },
    2: {
      question: 'Veeso は AI 画像生成ツールとどう違いますか？',
      answer_p1:
        '多くの AI デザインツールは画像を生成します。Veeso は、以下を備えた完全に編集可能なデザインファイルを生成します：',
      list: [
        '編集可能なテキストブロック',
        '論理的なコンテンツ階層',
        'マルチページのフォーマット',
        '書き出し可能なデザイン',
      ],
    },
    3: {
      question: 'Veeso AI は誰のためのツールですか？',
      answer:
        'Veeso は、デザイナーを雇ったりコンテンツの体裁を整えるのに何時間も費やしたりせずに、プロのデザインを必要とするクリエイター、ソロ創業者、マーケター、中小企業（SMB）のために設計されています。',
    },
    4: {
      question: 'コアとなる「コンテンツファースト」の思想とは何ですか？',
      answer_p1:
        'コンテンツファーストとは、デザインがテンプレートや画像ではなく、あなたの情報から始まるという考え方です。固定のテンプレートを探してコンテンツを無理やり当てはめる代わりに、Veeso はあなたの素のテキストを分析し、明確なセクション、見出し、ビジュアル階層へと自動的に構造化します。あなたのコンテンツは次のものに閉じ込められるべきではありません：',
      list_a: [
        '特定のスライドレイアウト',
        '固定的なテンプレート',
        '単一プラットフォームのフォーマット',
      ],
      answer_p2: 'Veeso はコンテンツとフォーマットを分離し、同じ入力を以下に変換できます：',
      list_b: ['プレゼンテーション', 'ニュースレター', 'SNS 投稿', 'レポート', 'パンフレット'],
      answer_p3: 'コンテンツのソースは一つ。デザインのアウトプットは複数。',
    },
    5: {
      question: 'Veeso における「コンテンツ」とは何ですか？',
      answer:
        'Veeso におけるコンテンツとは、メッセージを伝えるあらゆる素材を指します。下書きテキスト、箇条書き、ブログ記事、投資家向けメモ、製品説明、SNS コピー、レポート、画像、参考資料などを含みます。情報を伝えるものなら何でも、構造化されたデザイン出力に変換できます。',
    },
    6: {
      question: 'マジックテンプレートとは何ですか？',
      answer_p1:
        'マジックテンプレートは Veeso AI のスタイル制御システムです。固定的・静的なテンプレートではなく、以下に基づいてレイアウト構造を動的に適応させます：',
      list: ['コンテンツの長さ', '情報の階層', 'トーンと意図', '出力フォーマット'],
      answer_p2:
        'セクション、見出し、ビジュアル、余白をインテリジェントに配置し、手作業のフォーマット調整なしにプロ品質のデザインファイルを作成します。',
    },
    7: {
      question: 'Veeso ではどのようなファイルを作成できますか？',
      answer:
        'プレゼンテーション、ニュースレター、SNS 投稿、レポート、ワンページャー、パンフレット、ロングフォームコンテンツページなどを作成できます。すべてあなたのオリジナルテキスト入力から生成されます。',
    },
    8: {
      question: '生成されたデザインを後から編集できますか？',
      answer:
        'はい。すべての出力は完全に編集可能です。書き出し前に Veeso 内でテキスト、レイアウト、画像、構造、ブランディング要素を直接調整できます。',
    },
    9: {
      question: 'Veeso で自社ブランドを使用できますか？',
      answer:
        'はい。自社のブランドスタイル、カラー、レイアウトを適用し、すべての素材で一貫したビジュアルアイデンティティを保てます。',
    },
    10: {
      question: 'Veeso には画像編集機能がありますか？',
      answer:
        'はい。構造化されたレイアウトの生成に加え、Veeso ではデザイン内の画像を編集・調整できます。すべてを一つのワークフローで完結できます。',
    },
    11: {
      question: 'Veeso ではどれくらいの速さでデザインを作成できますか？',
      answer:
        'ほとんどのユーザーは、素のコンテンツを数分で洗練された書き出し可能なデザインに変換できます。Veeso は構造とビジュアル階層を自動化することで、フォーマットとレイアウトにかかる時間を削減します。',
    },
    12: {
      question: 'Veeso は無料で使えますか？',
      answer:
        'はい。Veeso は毎日リフレッシュされるクレジットを含む無料プランを提供しており、初期費用なしで試して制作できます。より多くのクレジットと高度な機能のために有料プランへアップグレードすることも可能です。',
    },
    title: 'よくある質問',
  },
  roles: {
    heading_1: 'デザインを待つのは、もう終わり',
    heading_2: '大量生成を、今すぐ始めよう',
    description:
      '次のコピーを 60 秒で納品レベルのビジュアルに。バッチ生成、完全編集可能、デザインスキル不要。',
    cta: '今すぐデザイン',
  },
  footer: {
    sr_only: 'フッター',
    col: {
      design_tools: 'デザインツール',
      resources: 'リソース',
      company: '会社情報',
      connect: 'フォロー',
    },
    link: {
      help: 'ヘルプセンター',
      solutions: 'ソリューション',
      tools: 'ツール',
      learn: '学ぶ',
      blog: 'ブログ',
      spotlight: 'スポットライト',
      changelog: '更新履歴',
      affiliates: 'アフィリエイト',
      about: '会社概要',
      contact: 'お問い合わせ',
      terms: '利用規約',
      privacy: 'プライバシー',
      cookie_policy: 'Cookie ポリシー',
      x: 'X',
      linkedin: 'LinkedIn',
      discord: 'Discord',
    },
    tooltip: {
      coming_soon: '近日公開',
    },
    copyright: '© {{year}} Veeso AI.',
  },
};
